import { render, staticRenderFns } from "./succession.vue?vue&type=template&id=de6526d8&scoped=true&"
import script from "./succession.vue?vue&type=script&lang=js&"
export * from "./succession.vue?vue&type=script&lang=js&"
import style0 from "./succession.vue?vue&type=style&index=0&id=de6526d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6526d8",
  null
  
)

export default component.exports